(function () {
  function reorderControl(control) {
    var label = control.querySelector(
      ':scope > .material_filled-label.globo-label, :scope > .flat-label.globo-label'
    );
    if (!label) return;

    var description = control.querySelector(':scope > .help-text.globo-description');
    var moveToTop = control.querySelector(':scope > .description-move-to-top');
    var formInput = control.querySelector(':scope > .globo-form-input');
    var messages = control.querySelector(':scope > .messages');

    // Case 1: .description-move-to-top is a direct child of the control
    // Target order: label → instruction → upload → help text/example → messages
    if (moveToTop) {
      label.insertAdjacentElement('afterend', moveToTop);

      if (description) {
        if (formInput) {
          formInput.insertAdjacentElement('afterend', description);
        } else if (messages) {
          messages.insertAdjacentElement('beforebegin', description);
        } else {
          control.appendChild(description);
        }
      }

      control.classList.add('has-description-move-to-top');
      return;
    }

    if (!description) return;

    // Case 2: .description-move-to-top is inside .help-text.globo-description
    var moveToTopChild = description.querySelector(':scope > .description-move-to-top');
    if (moveToTopChild) {
      label.insertAdjacentElement('afterend', moveToTopChild);

      if (formInput) {
        formInput.insertAdjacentElement('afterend', description);
      }

      control.classList.add('has-description-move-to-top');
      return;
    }

    // Case 3: default — move entire description after label
    label.insertAdjacentElement('afterend', description);
  }

  function moveDescriptions(root) {
    root = root || document;

    root.querySelectorAll('.globo-form-app .globo-form-control').forEach(reorderControl);
  }

  document.addEventListener('DOMContentLoaded', function () {
    moveDescriptions();
  });

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;

        if (node.classList && node.classList.contains('globo-form-app')) {
          moveDescriptions(node);
        }

        var inner = node.querySelectorAll && node.querySelectorAll('.globo-form-app');
        if (inner && inner.length) {
          inner.forEach(function (f) {
            moveDescriptions(f);
          });
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
